import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LevelAdm, LevelDev, LevelNil, LevelCnf, ROUTES, LevelAbs } from './app-config';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './routes/home/home.component';
import { EditControleFinancasComponent } from './routes/controle-financas/edit/edit-controle-financas.component';
import { CreateUsuarioComponent } from './routes/usuarios/create/create-usuario.component';
import { EditUsuarioComponent } from './routes/usuarios/edit/edit-usuario.component';
import { CreateVeiculoComponent } from './routes/veiculos/create/create-veiculo.component';
import { EditVeiculoComponent } from './routes/veiculos/edit/edit-veiculo.component';
import { ListVeiculosSemUsuarioComponent } from './routes/veiculos/list-veiculos-sem-usuario/list-veiculos-sem-usuario.component';
import { ListControleFinancaMovimentosFiltroComponent } from './routes/controle-financas/list-movimentos-filtro/list-controle-financa-movimentos-filtro.component';
import { SqlComponent } from './routes/sql/sql.component';
import { CoresComponent } from './routes/cores/cores.component';
import { ConfiguracoesComponent } from './routes/configuracoes/configuracoes.component';

const stdRoutes: Routes = [{
  path: "",
  pathMatch: "full",
  component: HomeComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelNil }
},{
  path: "novo-usuario",
  component: CreateUsuarioComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "usuario/:id",
  component: EditUsuarioComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "controle-financa/:id",
  component: EditControleFinancasComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelCnf }
},{
  path: "controle-financa-movimentos-filtro",
  component: ListControleFinancaMovimentosFiltroComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelCnf }
},{
  path: "novo-veiculo",
  component: CreateVeiculoComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAbs }
},{
  path: "veiculos-sem-usuario",
  component: ListVeiculosSemUsuarioComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "veiculo/:id",
  component: EditVeiculoComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAbs }
},{
  path: "sql",
  component: SqlComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "cores",
  component: CoresComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "configuracoes",
  component: ConfiguracoesComponent,
  canActivate: [AuthGuard],
  data: { roles: LevelAdm }
},{
  path: "**",
  redirectTo: "",
  canActivate: [AuthGuard],
  data: { roles: LevelNil }
}];

const navRoutes: Routes = ROUTES.map(nav => {
  return {
    path: nav.route,
    component: nav.component,
    canActivate: [AuthGuard],
    data: { roles: nav.authLevel }
  };
});

@NgModule({
  imports: [RouterModule.forRoot(navRoutes.concat(stdRoutes))],
  exports: [RouterModule]
})
export class AppRoutingModule { }
